import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

export const PricePerContainer = styled.div`
  margin-top: 1rem;
`;

export const PricePerLine = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.token('text-default')};
  font: ${brandFont.headerOne};
  margin-top: 0.3rem;
  font-weight: 300;
  font-size: 1.1rem;
  line-height: 1.25rem;
  text-transform: none;
`;
